import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import { Slide } from '@material-ui/core';
import { GlobalContext } from '../../../services/global/GlobalState';

const useStyles = makeStyles((theme) => ({
  alert: {
    backgroundColor: '#fafafa',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
  },
}));

export const SubscribeAlert = () => {
  const classes = useStyles();
  const { isScroll, openSubscribeAlert, setOpenSubscribeAlert } =
    useContext(GlobalContext);

  const alertBox = {
    width: '100%',
    position: 'sticky',
    top: isScroll ? 0 : 64,
    zIndex: 100,
  };

  const HideOnScroll = ({ children }) => {
    return (
      <Slide appear={true} direction='down' in={true}>
        {children}
      </Slide>
    );
  };

  return (
    <div style={alertBox}>
      <HideOnScroll>
        <Collapse in={openSubscribeAlert}>
          <Alert
            className={classes.alert}
            variant='outlined'
            severity='success'
            action={
              <IconButton
                aria-label='close'
                color='inherit'
                size='small'
                onClick={() => {
                  setOpenSubscribeAlert(false);
                }}
              >
                <CloseIcon fontSize='inherit' />
              </IconButton>
            }
          >
            Thanks for entering your email address. we will inform you of the
            latest updates.
          </Alert>
        </Collapse>
      </HideOnScroll>
    </div>
  );
};
